import { StatelessComponent, MouseEventHandler, AnchorHTMLAttributes } from 'react'
import * as styles from 'styles/atoms/buttons/LinkButton.css'
import * as cn from 'classnames'
import { ButtonStyleProps, getButtonClassName } from 'components/features/pfm/Button/Button'

export type LinkButtonProps =
  & {
    text?: string
    onClick?: MouseEventHandler<HTMLLinkElement>
  }
  & AnchorHTMLAttributes<{}>
  & ButtonStyleProps

const LinkButton: StatelessComponent<LinkButtonProps> = (props) => {
  const {
    children,
    text,
    href,
    rel: relProp,
    target,
  } = props
  const className = getButtonClassName(props)

  const rel = !relProp && target === '_blank'
    ? 'noopener noreferrer'
    : relProp

  return (
    <a href={ href } target={ target } rel={ rel }>
      <div className={ cn(className, styles.linkWrapper) }>
        { children || text }
      </div>
    </a>
  )
}

LinkButton.defaultProps = {
  fullWidth: false,
  theme: 'blue',
  size: 'medium',
}

export default LinkButton
